import React, { useEffect, useState } from 'react';
import { BodyText, Divider, HeadingText, ContextualAlert, Row, Col, Link, Button } from '@paypalcorp/pp-react';
import { parseMessages } from '../../utilityHelper';
import { get } from 'lodash';
import * as FPT from '../../utility/fpt';
import { LogoContainer } from './LogoContainer';

export const Profile = (props) => {
    const messages = parseMessages('givingfund');
    const [logo, setLogo] = useState({ defaultLogoSrc: get(props.charityInfo, 'logo_url', ''), src: get(props.charityInfo, 'logo_url', ''), error: props.charityInfo?.mediaservErr, openModal: false });
    const handleLogoSave = async () => {
        let logoObj = { ...logo };
        logoObj.openModal = false;
        FPT.trackButtonClick('SaveLogoBtn');
        const success = await props.onSubmitProfileForm({ logo: logo.file });
        !success && setLogo({ src: get(props.charityInfo, 'logo_url', ''), error: 'try-again', openModal: false });
    }
    useEffect(() => {
        FPT.trackPage('main:givingfund:profile');
    }, []);

    useEffect(() => {
        setLogo({ src: get(props.charityInfo, 'logo_url', ''), error: props.charityInfo?.mediaservErr, openModal: false });
    }, [props]);

    return (<div className="profile">
        <Row>
            <Col xs={12} xxl={10}>
                <LogoContainer onSave={handleLogoSave} messages={messages.profile} logo={logo} setLogo={setLogo} charityInfo={props.charityInfo} />
            </Col>
            <Col xs={12} xxl={2}>
                <Button tertiary onClick={() => props.setProfileEditView('profile', 'editProfileBtn')}>{messages.profile.edit}</Button>
            </Col>
        </Row>
        <Divider className="divider" />
        <HeadingText size="sm" className="subHeader">{messages.profile.description.label}</HeadingText>
        {get(props, 'charityInfo.description') ? <BodyText>{props.charityInfo.description}</BodyText> :
            <ContextualAlert className="warningMsg" type="warning">{messages.profile.description.alert}</ContextualAlert>}
        <Divider className="divider" />
        <HeadingText size="sm" className="subHeader">{messages.profile.slogan.label}</HeadingText>
        {get(props, 'charityInfo.slogan') ? <BodyText>{props.charityInfo.slogan}</BodyText> :
            <ContextualAlert className="warningMsg" type="warning">{messages.profile.slogan.alert}</ContextualAlert>}
        <Divider className="divider" />
        <HeadingText size="sm" className="subHeader">{messages.profile.missionArea.category}</HeadingText>
        {get(props, 'charityInfo.missionArea.id') ?
            (<React.Fragment>
                <BodyText>{messages[props.charityInfo.missionArea.id]}</BodyText>
                {get(props, 'charityInfo.missionAreaSecond.id') && <BodyText>{messages[props.charityInfo.missionAreaSecond.id]}</BodyText>}
                {get(props, 'charityInfo.missionAreaThird.id') && <BodyText>{messages[props.charityInfo.missionAreaThird.id]}</BodyText>}
            </React.Fragment>) :
            (<ContextualAlert className="warningMsg" type="warning">{messages.profile.missionArea.alert}</ContextualAlert>)}
        <Divider className="divider" />
        <HeadingText size="sm" className="subHeader">{messages.profile.keywords.label}</HeadingText>
        {get(props, 'charityInfo.keywords') ?
            (<BodyText>{props.charityInfo.keywords}</BodyText>) :
            (<ContextualAlert className="warningMsg" type="warning">{messages.profile.keywords.alert}</ContextualAlert>)
        }
        <Divider className="divider" />
        <Link target="_blank" data-fpti="fundraisingHub" href={`/fundraiser/charity/${props.charityInfo.nonprofit_id}`}>{messages.profile.donation.experience.link}</Link>
    </div>)
};